export class MapPoint {
    public constructor(
        public id: string,
        public latitude: number,
        public longitude: number,
        public title: string,
        public url: string,
        public image: string,
        public numberOfImages: number,
        public description: string,
        public exactLocation: boolean,
        public priceTag: string,
        public bedrooms: string,
        public bathrooms: string,
        public area: string,
        public location: string,
        public carSpaces: string,
        public moreInfo: string,
        public updatedDate: string,
        public publisherName: string,
    ) {
        this.latitude = latitude;
        this.longitude = longitude;
        this.title = title;
        this.url = url;
        this.image = image;
        this.numberOfImages = numberOfImages;
        this.description = description;
        this.exactLocation = exactLocation;
        this.id = id;
        this.priceTag = priceTag;
        this.bedrooms = bedrooms;
        this.bathrooms = bathrooms;
        this.area = area;
        this.location = location;
        this.carSpaces = carSpaces;
        this.moreInfo = moreInfo;
        this.updatedDate = updatedDate;
        this.publisherName = publisherName;
    }
}

export let emptyMapPoint = () => new MapPoint(
    "",
    0,
    0,
    "",
    "",
    "",
    0,
    "",
    false,
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    ""
);